import OrganizationsTable from './OrganizationsTable'
export default OrganizationsTable


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/MappingTabs/OrganizationTab/OrganizationTable/index.js